import '../../App.scss'
import Fade from 'react-reveal/Fade';

export default function Events(content) {
    let { Title, Featuring, Image, Description, Location, Date, Time, Cost, Link } = content.content
    if(content.content.Image === '' || content.content.Image === undefined){
        Image = 'https://lh3.googleusercontent.com/pw/ACtC-3dDzS78QJB5lujL5JM49hL5OXasBqdqj9YBnl5kbXpdkj4jDkjoWlaoe0UaH03DokTjQVokVc2ttN_Amv5bXrEunQVYaO09QgXnZX7ETM0ACCWhIAbhsJ9qUbqMmYmX8IzXEBbCbQCUzT-SR0NKGfi9pg=w1552-h872-no?authuser=0';
    }

    return (
        <div className="Event">
            <div className="Columns-Between">
                <div className="DateBlock">
                    <h2>{Date}</h2>
                    <p>{Time}</p>
                </div>
                <div className="LocationBlock">
                    <h2>Cost: {Cost}</h2>
                    <p>{Location}</p>
                </div>
            </div>
            <div className="InfoBlock">
                <h2>{Featuring}: {Title}</h2>

            </div>
            <p>{Description}</p>
            <a href={Link} target="_blank" rel="noreferrer">
                <div className="Register">Register</div>
            </a>
            <img src={Image} alt="Event Image" />
        </div>
    );
}
